__turbopack_context__.v({
  "card": "CascadingLoads-module__3VS7Yq__card",
  "cardBadge": "CascadingLoads-module__3VS7Yq__cardBadge",
  "cardDensity": "CascadingLoads-module__3VS7Yq__cardDensity",
  "cardHeader": "CascadingLoads-module__3VS7Yq__cardHeader",
  "cardLatency": "CascadingLoads-module__3VS7Yq__cardLatency",
  "cardLines": "CascadingLoads-module__3VS7Yq__cardLines",
  "cardPending": "CascadingLoads-module__3VS7Yq__cardPending",
  "cardTitle": "CascadingLoads-module__3VS7Yq__cardTitle",
  "cards": "CascadingLoads-module__3VS7Yq__cards",
  "controls": "CascadingLoads-module__3VS7Yq__controls",
  "densityButton": "CascadingLoads-module__3VS7Yq__densityButton",
  "densityButtonSelected": "CascadingLoads-module__3VS7Yq__densityButtonSelected",
  "hint": "CascadingLoads-module__3VS7Yq__hint",
  "modeBadge": "CascadingLoads-module__3VS7Yq__modeBadge",
  "modeLegend": "CascadingLoads-module__3VS7Yq__modeLegend",
  "modeOption": "CascadingLoads-module__3VS7Yq__modeOption",
  "modePicker": "CascadingLoads-module__3VS7Yq__modePicker",
  "preferenceBar": "CascadingLoads-module__3VS7Yq__preferenceBar",
  "preferenceGroup": "CascadingLoads-module__3VS7Yq__preferenceGroup",
  "preferenceLabel": "CascadingLoads-module__3VS7Yq__preferenceLabel",
  "root": "CascadingLoads-module__3VS7Yq__root",
});
